import { render, staticRenderFns } from "./CreateCorrespondenceDocumentDlg.vue?vue&type=template&id=4e7c34fa"
import script from "./CreateCorrespondenceDocumentDlg.vue?vue&type=script&lang=js"
export * from "./CreateCorrespondenceDocumentDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports